import { SimpleDateTimeStringFilter } from './simpleDateTimeString';
import { DueDateMessageFilter } from './dueDateMessage'
import { SortContentFilter } from './sortContent';
import { GetBadgeCountFilter } from './badgeCount';
import { EncodeUrlFilter } from './encodeUrl';
import { fileIconsModule } from './fileIcons';
import { LinkRightsIconFilter } from './rightsIcon';
import { UsersFilter } from './users';
import { DataGridFilter } from './dataGrid';

export * from './fileIcons';
export const filtersModule = angular
	.module('sharebase.filter', [
		'gettext',
		fileIconsModule.name
	])
	.filter('sbSimpleDateTimeString', SimpleDateTimeStringFilter)
	.filter('sbDueDateMessage', DueDateMessageFilter)
	.filter('sbSortContent', SortContentFilter)
	.filter('sbBadgeCount', GetBadgeCountFilter)
	.filter('sbEncodeUrl', EncodeUrlFilter)
	.filter('sbLinkRightsIcon', LinkRightsIconFilter)
	.filter('sbFilterUsers', UsersFilter)
	.filter('sbDataGrid', DataGridFilter);


// WEBPACK FOOTER //
// ./src/sharebase/filters/index.ts